import { render, staticRenderFns } from "./AssetLeakEdit.vue?vue&type=template&id=bb046aa4&"
import script from "./AssetLeakEdit.vue?vue&type=script&lang=js&"
export * from "./AssetLeakEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports